import { render } from "./HeroiconsSolidUserAdd.vue?vue&type=template&id=050aea75"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUserAdd.vue"]])

export default __exports__